import { render, staticRenderFns } from "./StaffSelectionModal.vue?vue&type=template&id=5052f3c6&scoped=true&"
import script from "./StaffSelectionModal.vue?vue&type=script&lang=js&"
export * from "./StaffSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./StaffSelectionModal.vue?vue&type=style&index=0&id=5052f3c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052f3c6",
  null
  
)

export default component.exports